var map = {
	"./1.jpg": 138,
	"./10.jpg": 139,
	"./2.jpg": 140,
	"./3.jpg": 141,
	"./4.jpg": 142,
	"./5.jpg": 143,
	"./6.jpg": 144,
	"./7.jpg": 145,
	"./8.jpg": 146,
	"./9.jpg": 147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 137;